/**
 * Created by zzt on 19/1/9.
 * http配置
 */

import axios from 'axios'
import store from '@/store'

// import localStorage from '@/storage/localStorage'
import cookie from '@/storage/cookies.js'
// import { config } from 'vue/types/umd'

// import store from '@/store'
// import router from '@/router'
import { gernerateStrV1, decryptJson } from '@/utils/SpiderHack.js'
const gcgdAxios = axios.create();
window.pending = []
let pending = window.pending
let cancelToken = axios.CancelToken
let removePending = (config) => {
  let clubApi = (config.url.split('/')).pop()
  if (clubApi !== 'search') {
    for (let p in pending) {
      if (pending[p].u === config.url + JSON.stringify(config.data) + JSON.stringify(config.params) + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
        pending[p].f() // 执行取消操作
        pending.splice(p, 1)
      }
    }
  }
}

// axios 基础配置
gcgdAxios.defaults.timeout = 50000
gcgdAxios.defaults.baseURL = process.env.VUE_APP_APITEAM
// axios.defaults.baseURL = 'http://192.168.2.42:9999'

gcgdAxios.interceptors.request.use(
  config => {
    let token = cookie.cookieRead('token')
    // if (config.url == "http://192.168.2.42:9999") {
    if (config.url !== `${process.env.VUE_APP_APITEAM}/file/addFiles`) {


      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      if (config.url == `${process.env.VUE_APP_LOGINAPI}/authentication/sv1/user`) {
        config.headers.tag = 'member'
      }
      let cookieArea = cookie.cookieRead('area')
      let area = cookieArea ? JSON.parse(cookieArea) : null
      if (area) {
        if (config.method === 'post') {
          config.data = {
            ...config.data,
          }
        } else if (config.method === 'get') {
          config.params = {
            ...config.params
          }
        }
      }
    }
    removePending(config) // 在一个axios发送前执行一下取消操作
    config.cancelToken = new cancelToken((c) => {
      // 这里的axios标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
      // 暂留待测试
      pending.push({
        u: config.url + JSON.stringify(config.data) + JSON.stringify(config.params) + '&' + config.method,
        f: c
      }) // config.data为请求参数
    })
    //添加加密头
    let sign = gernerateStrV1()
    config.headers.sign = sign

    return config
  },
  error => {
    //
    //
    return Promise.reject(error)
  }
)

// http response interceptors
gcgdAxios.interceptors.response.use(
  response => {
    removePending(response.config) // 在一个axios响应后再执行一下取消操作，把已经完成的请求从pending中移除
    //
    //解析加密头
    if (response.headers.isencryption && response.headers.isencryption == 1 && response.data.payload) {
      let param = ['data', 'result', 'records']
      let current = param.find(i => i in response.data)
      if (current) {
        let decryptData = decryptJson(response.data.payload)
        let dataType = response.headers.datatype
        let handler = { 'object': JSON.parse, 'list': JSON.parse, 'long': parseFloat, 'integer': parseFloat, 'boolean': (parse) => typeof (parse) == 'boolean' ? parse : typeof (parse) == 'string' && parse == 'true' ? true : false }
        response.data[current] = handler[dataType] ? handler[dataType](decryptData) : decryptData;
      }
    }
    return response
  },
  error => {
    //
    //
    // )
    //
    //
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit('LOGIN_OUT')
          break
      }
    }
    //处理http头状态
    // return { data: error.response.data, code: error.response.status };
    //return Promise.reject(error.response)
    // return Promise.reject(error)
    // return error

    return Promise.reject(
      error.response && error.response.data
        ? error.response.data
        : error.response
        ? error.response
        : error
    );
  }
)
export default {
  get(url, params, config = {}) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        ...config,
        method: 'get',
        params,
        url
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    })
  },
  getParams(url, params, searchParam) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        method: 'get',
        params,
        searchParam,
        url
      }).then(res => {
        resolve(res)
      }).catch(function (error) {
        //
      })
    })
  },
  post(url, data) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        method: 'post',
        data,
        url
      }).then(res => {
        //
        //
        resolve(res)
      }).catch(error => {
        //
        //
        resolve(error)
      })
    })
  },
  postParams(url, params) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        method: 'post',
        params,
        url
      }).then(res => {
        resolve(res)
      })
    })
  },
  postParamsData(url, params, data) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        method: 'post',
        params,
        data,
        url
      }).then(res => {
        resolve(res)
      })
    })
  },
  postLogin(url, params) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        method: 'post',
        headers: {
          'Authorization': 'Basic Z2N0eDpnY3R4'
        },
        url,
        params
      }).then(res => {
        resolve(res)
      })
    })
  },
  put(url, data) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        method: 'put',
        data,
        url
      }).then(res => {
        resolve(res)
      })
    })
  },
  patch(url, data) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        method: 'patch',
        data,
        url
      }).then(res => {
        resolve(res)
      })
    })
  },
  delete(url) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        method: 'delete',
        url
      }).then(res => {
        resolve(res)
      })
    })
  },
  getLogin(url, params, options = {}) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        // ...options,
        method: "get",
        params,
        url,
        withCredentials: true
      }).then(res => { resolve(res) })
    })
  },
  memberUser: async function (data) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_API_LOGIN}/v1/user/memberUser/me`;
      let params = {}
      gcgdAxios({
        // ...options,
        method: "get",
        params,
        url,
        withCredentials: true
      }).then(res => { resolve(res) }).catch(err => {
        reject(err);
      });
    });
  },
  addFile (data, params) {
    return new Promise((resolve, reject) => {
      gcgdAxios({
        url: `${process.env.VUE_APP_APITEAM}/file/addFiles`,
        method: 'post',
        headers: {
          'Content-type': 'multipart/form-data'
        },
        data,
        onUploadProgress: (progressEvent) => {
          let num = ((progressEvent.loaded / progressEvent.total) * 100) | 0
          params.onProgress({ percent: num })
        }
      }).then(res => {
        resolve(res)
      }).catch(err=>{
        reject(err)
      })
    })
  }
}
